import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Done, Edit } from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";
import { classHOC } from "components/app/ClassWrapper";
import { fullMenuConfig } from "components/portfolio/GridViewFunction/CoverageStatus";
import { FEATURE_KEY } from "constant";
import { useAxios } from "myAxios";
import { useRouter } from "next/router";
import { AuthProvider } from "pages";
import React, { CSSProperties, FC, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { AnchorHistory, CoverageStatusHistory } from "types/portfolio";
import ExceptionDialog from "../NewEM/ExceptionDialog";
import HistoryList from "./AnchorProductRenderer/HistoryList";

interface MenuItem {
  label: string;
  iconSrc: string;
  mark: string;
}

interface PostParams {
  reason: string | null;
  accountKeys: string[];
  coverageStatus?: string;
  engagementValue?: string;
  wemField?: string;
}

const useStyles = makeStyles(() => ({
  common: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 4px",
    borderRadius: 2,
    fontFamily: "CiscoSansTT",
    fontSize: 9,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "14px",
    marginLeft: 8,
  },
  auto: {
    background: "#DEDEDE",
    color: "#252B34",
  },
  manual: {
    background: "#C3E9FE",
    color: "#0A78CC",
  },
  MuiListItemIcon: {
    minWidth: 20,
  },
  MuiListItemTextPrimary: {
    color: "#333",
    fontFamily: "CiscoSansTT",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "12px",
  },
  clearText: {
    // color: "#aaa",
    fontFamily: "CiscoSansTT",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "12px",
  },
  changeText: {
    color: "#777",
    fontFamily: "CiscoSansTT",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "18px",
    pointerEvents: "none",
  },
  delText: {
    color: "#aaa",
  },
  optionWrapper: {
    display: "flex",
    alignItems: "center",
  },
  option: {
    display: "flex",
    alignItem: "center",
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: "#EBFAFF",
    },
    "&:focus": {
      backgroundColor: "#EBFAFF",
    },
    "&:active": {
      backgroundColor: "#EBFAFF",
    },
    "&:select": {
      backgroundColor: "#EBFAFF",
    },
  },
  leftWrapper: {
    display: "flex",
  },
}));

const CoverageStatusRenderer: FC<
  Partial<ICellRendererParams> & {
    valueCheck?: boolean;
    customStyle?: CSSProperties;
    type?: string;
    colId?: string;
    editCallback?: (data: string, aemVal?: string) => void;
    mutate?: any;
    aemEditable?: boolean;
    wemEditable?: boolean;
  }
> = ({
  node,
  data,
  value,
  column,
  api,
  valueCheck = false,
  customStyle,
  type = "account",
  colId,
  editCallback,
  mutate,
  aemEditable = true,
  wemEditable = true,
}) => {
  const classes = useStyles();
  const authDetail = useContext(AuthProvider);
  const axios = useAxios();
  const router = useRouter();
  const historyInfo: {
    label: string;
    field: keyof AnchorHistory & CoverageStatusHistory;
    apiKey: string;
    valueFormat: boolean;
  } = {
    label: colId
      ? colId?.includes("wem")
        ? "Workload Engagement Model"
        : "Account Engagement Model"
      : column?.getColDef()?.headerName?.includes("WEM")
        ? "Workload Engagement Model"
        : (column?.getColDef()?.headerName ?? "Account Engagement Model"),
    field: "value" as keyof AnchorHistory & CoverageStatusHistory,
    apiKey:
      column?.getColId() === "coverageStatus" || colId === "coverageStatus"
        ? "coverage-status"
        : ((column?.getColId() || colId) ?? ""),
    valueFormat: false,
  };
  const [detailVal, setDetailVal] = useState("");

  // const editCallback = (value: StatusChipType) => {
  //   axios
  //     .put(`/api/dataservice/v1/accounts/coverage-status`, {
  //       coverageStatus: value,
  //       accountKeys: [data.accountKey],
  //     })
  //     .then(() => {
  //       node?.setDataValue(column!, value);
  //       if (valueCheck) {
  //         api?.forEachNode((n) => {
  //           if (
  //             n.data.accountKey === data.accountKey &&
  //             n.data.coverageStatus !== value
  //           ) {
  //             n.setDataValue(column!, value);
  //           }
  //         });
  //         api?.redrawRows();
  //       }
  //     })
  //     .catch((e) => {
  //       toast.error(
  //         e?.response?.data?.message ||
  //           `Failed to update ${
  //             column?.getColDef()?.headerName ?? "Account Engagement Model"
  //           }`,
  //         { position: "top-center", autoClose: 3000 }
  //       );
  //     });
  // };

  // const handleOpen = () => {
  //   setOpen(true);
  // };
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);
  const [selected, setSelected] = useState("");
  const [exceptionOpen, setExceptionOpen] = useState(false);
  const [isCGEM, setIsCGEM] = useState<boolean>(false);
  //const [fedFlag, setFedFlag] = useState<boolean>(false);
  const [isAmericas, setIsAmericas] = useState<boolean>(false);

  const wemPageIds = ["summary", "portfolio"];
  const otherPage = ["activity", "renewals", "task", "email"];

  const wemSuiteArr = data?.invoiceArrMeetingMsgCloud + data?.invoiceArrCallingCloud;

  // 1. exective : aemEditable --> cannot edit
  // 2. summary -> suite arr= 0 ===> wemEditable --> cannot edit
  // 3. portfolio : wemSuite column --> only have value can edit
  // 4. portfolio : wemCallingOnPrem column cannot edit
  // 5. other page , all can edit
  let editable =
    ((aemEditable && router.pathname.includes("executive")) ||
      (wemEditable && wemPageIds.includes(router.pathname)) ||
      (column?.getColId() === "wemSuite" && Boolean(wemSuiteArr)) ||
      (aemEditable &&
        wemEditable &&
        !otherPage.includes(router.pathname) &&
        column?.getColId() !== "wemSuite" &&
        column?.getColId() !== "wemCallingOnPrem")) &&
    authDetail.features.includes(FEATURE_KEY.UPDATE_ACCOUNT_COVERAGE);

  // let executive the same as portfolio about wem
  if (
    wemEditable &&
    router.pathname === "/spng/dashboard/executive" &&
    column?.getColId() === "wemCallingOnPrem"
  ) {
    editable = false;
  } else if (
    wemEditable &&
    router.pathname === "/spng/dashboard/executive" &&
    column?.getColId() === "wemSuite"
  ) {
    editable = Boolean(data?.invoiceArrSuite);
  }

  const shortenValue =
    (column?.getColId()?.includes("wem") || colId?.includes("wem")) &&
    router?.pathname?.includes("summary") &&
    colId !== "wemSuite";

  const handleShowExp = () => {
    const field = colId ?? column?.getColId();
    if (router.pathname === "/spng/task") {
    }
    switch (field) {
      case "coverageStatus":
        if (router.pathname === "/spng/task") {
          return data?.activityInfo?.aemExpReason;
        } else {
          return data?.aemExpReason;
        }
      case "wemMeeting":
        return data?.wemMeetingExpReason;
      case "wemCallingCloud":
        return data?.wemCallingCloudExpReason;
      case "wemCallingOnPrem":
        // return data?.wemCallingOnPremExpReason;
        return false;
      case "wemContactCenter":
        return data?.wemContactCenterExpReason;
      case "wemVideoDevice":
        return data?.wemVideoDeviceExpReason;
      case "wemSuite":
        return data?.wemSuiteExpReason;
    }
  };

  const greyClearOption = !Boolean(handleShowExp());

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateCallback = (wemVal: string, aemVal?: string) => {
    setDetailVal(wemVal);
    editCallback?.(`${colId}:${colId?.includes("wem") ? wemVal : aemVal}`, aemVal);
  };

  const handleChange = (item: string) => () => {
    setSelected(item);
    setExceptionOpen(true);
    setAnchorEl(null);
  };

  const getLatestWEM = () => {
    axios
      .get(`/api/dataservice/v1/accounts/${data?.accountId}?includeSites=true&usingBundle=true`)
      .then((res) => {
        const result = res.data;
        if (result) {
          node?.setDataValue(
            `${colId ? colId : (column?.getColId() as string)}ExpBy`,
            result[`${colId ? colId : (column?.getColId() as string)}ExpBy` as keyof typeof result]
          );
          node?.setDataValue(
            `${colId ? colId : (column?.getColId() as string)}ExpDate`,
            result[
              `${colId ? colId : (column?.getColId() as string)}ExpDate` as keyof typeof result
            ]
          );
        }
      })
      .catch(() => {
        toast.error("Fail to get latest wem", {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  const clearException = async () => {
    let postData: PostParams = {
      reason: null,
      accountKeys: [data?.accountKey],
    };
    if (type === "account") {
      // AEM
      postData = {
        ...postData,
        coverageStatus: value || detailVal,
      };
    } else {
      postData = {
        // WEM
        ...postData,
        engagementValue: value || detailVal,
        wemField: colId ? colId : (column?.getColId() as string),
      };
    }
    axios
      .put(`/api/dataservice/v1/accounts/${type}-engagement-model`, postData)
      .then((res) => {
        //   console.log(res.data);
        const result = res.data;
        if (type === "account") {
          if (router.pathname === "/spng/task") {
            node?.updateData({
              ...node.data,
              activityInfo: {
                ...node.data.activityInfo,
                coverageStatus: result?.[data?.accountKey] ?? "N/A",
                aemExpReason: null,
              },
            });

            updateCallback?.(result?.[data?.accountKey] ?? "N/A");

            if (valueCheck) {
              api?.forEachNode((n) => {
                if (
                  n.data.accountKey === data.accountKey &&
                  n.data.activiityInfo?.coverageStatus !== result?.[data?.accountKey]
                ) {
                  node?.updateData({
                    ...node.data,
                    activityInfo: {
                      ...node.data.activityInfo,
                      coverageStatus: result?.[data?.accountKey] ?? "N/A",
                      aemExpReason: null,
                    },
                  });
                  // if (
                  //   router.pathname?.includes("portfolio") ||
                  //   router.pathname?.includes("summary")
                  // ) {
                  // }
                }
              });
              api?.redrawRows();
            }
          } else {
            node?.setDataValue("coverageStatus", result?.[data?.accountKey] ?? "N/A");
            node?.setDataValue("aemExpReason", null);
            updateCallback?.(result?.[data?.accountKey] ?? "N/A");

            if (valueCheck) {
              api?.forEachNode((n) => {
                if (
                  n.data.accountKey === data.accountKey &&
                  n.data.coverageStatus !== result?.[data?.accountKey]
                ) {
                  n.setDataValue(
                    colId ? colId : (column?.getColId() as string)!,
                    result?.[data?.accountKey] ?? "N/A"
                  );
                  // if (
                  //   router.pathname?.includes("portfolio") ||
                  //   router.pathname?.includes("summary")
                  // ) {
                  n.setDataValue("aemExpReason", null);
                  // }
                }
              });
              api?.redrawRows();
            }
          }
        } else {
          // update WEM
          updateCallback?.(
            result?.[data?.accountKey]?.[0] ?? "N/A",
            result?.[data?.accountKey]?.[1] ?? "N/A"
          );
          // refresh wem by/date
          if (
            router.pathname === "/spng/portfolio" ||
            router.pathname === "/spng/dashboard/executive"
          ) {
            getLatestWEM();
          }
          node?.setDataValue(
            colId ? colId : (column?.getColId() as string)!,
            result?.[data?.accountKey]?.[0] ?? "N/A"
          );
          node?.setDataValue(`${colId ? colId : (column?.getColId() as string)}ExpReason`, null);
          // update AEM
          node?.setDataValue("coverageStatus", result?.[data?.accountKey]?.[1] ?? "N/A");
        }
        if (router.pathname.includes("summary")) {
          mutate?.();
        }
        handleClose();
      })
      .catch((e) => {
        // console.log(e);
        toast.error(e?.response?.data?.message || "Fail to clear exception", {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  const handleExpClose = () => {
    setExceptionOpen(false);
  };

  useEffect(() => {
    const info = router.pathname === "/spng/task" ? data?.activityInfo : data;
    if (info && Object.keys(info).length !== 0) {
      const checkCGEM = (info?.salesLevel5 ?? "").startsWith("GLL_");
      setIsCGEM(checkCGEM);
      setIsAmericas(info?.salesLevel1 === "Americas");
    }

    /* if (checkCGEM) {
        setIsAmericas(["AMERICAS", "LATAM"].includes(info?.contractTheatre));
      } else {
      } */
  }, [data]);

  if (node?.rowPinned) return null;

  if (!data || Object.keys(data).length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        ...customStyle,
      }}
    >
      <HistoryList
        accountKey={data?.accountKey}
        historyInfo={historyInfo}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: editable ? "pointer" : "auto",
        }}
        onClick={editable ? handleClick : undefined}
      >
        {/* <StatusChip
          type={colId ? detailVal || value || "N/A" : value || "N/A"}
          style={{ fontSize: 12, whiteSpace: "nowrap" }}
        /> */}
        {shortenValue ? (
          <Tooltip title={colId ? detailVal || value : value || "N/A"}>
            <span
              style={{
                maxWidth: colId === "wemCallingOnPrem" ? "3vw" : "4vw", // 50 90
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: 12,
                whiteSpace: "nowrap",
                fontWeight: "bold",
                color: fullMenuConfig.filter((i) =>
                  i.label === colId ? detailVal || value : value || "N/A"
                )?.length
                  ? fullMenuConfig.filter(
                      (i) =>
                        i.label ===
                        (colId
                          ? data?.suiteAnchor?.length
                            ? value
                            : detailVal || value
                          : value || "N/A")
                    )?.[0]?.color
                  : "inherit",
              }}
            >
              {colId ? (data?.suiteAnchor?.length ? value : detailVal || value) : value || "N/A"}
            </span>
          </Tooltip>
        ) : (
          <span
            style={{
              fontSize: 12,
              whiteSpace: "nowrap",
              fontWeight: "bold",
              color: fullMenuConfig.filter((i) =>
                i.label === colId ? detailVal || value : value || "N/A"
              )?.length
                ? fullMenuConfig.filter(
                    (i) => i.label === (colId ? detailVal || value : value || "N/A")
                  )?.[0]?.color
                : "inherit",
            }}
          >
            {colId ? detailVal || value : value || "N/A"}
          </span>
        )}
        {/* only have exp reason show E */}
        {Boolean(handleShowExp()) && (
          <Tooltip title={<Typography variant="body2">Exception Engagement Model</Typography>}>
            <img
              src="/portfolio/exception.svg"
              style={{ marginRight: 3 }}
              width={16}
              height={16}
            />
          </Tooltip>
        )}
        {/* <span>{colId ? detailVal || value : value || "N/A"}</span> */}
        {/* {editable && <KeyboardArrowDown style={{ fontSize: "1rem" }} />} */}
        {editable && <Edit style={{ fontSize: "1rem" }} />}
      </div>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={clearException}
          style={{ pointerEvents: greyClearOption ? "none" : "auto" }}
        >
          <ListItemIcon classes={{ root: classes.MuiListItemIcon }}>
            <img
              src={`${greyClearOption ? "/portfolio/trash-grey.svg" : "/portfolio/trash.svg"}`}
              style={{
                marginLeft: -2,
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Clear Manual Exception"
            className={classes.clearText}
            style={{ color: greyClearOption ? "#aaa" : "#333" }}
          />
        </MenuItem>
        <Divider style={{ height: 1 }} />
        <MenuItem className={classes.changeText}>
          <ListItemText primary="Change Engagement Model" />
        </MenuItem>
        {(() => {
          const currentLabel = detailVal || value;
          const currentItem = fullMenuConfig.find((m) => m.label === currentLabel);
          const currentPriority = currentItem?.priority ?? 5;
          return fullMenuConfig
            .filter(
              (m) =>
                m.condition(
                  isCGEM,
                  isAmericas,
                  ["PS FEDERAL AREA", "STR_PS FEDERAL AREA"].includes(data?.salesLevel3)
                ) &&
                (authDetail.features.includes(FEATURE_KEY.DOWNGRADE_ENGAGE_MODEL)
                  ? true
                  : m.priority <= currentPriority)
            )
            .map((item) => (
              <MenuItem
                key={item.label}
                value={item.label}
                onClick={handleChange(item.label)}
                className={classes.option}
              >
                <div className={classes.leftWrapper}>
                  <div className={classes.optionWrapper}>
                    <ListItemText
                      primary={item.label}
                      style={{ color: item.color }}
                    />
                  </div>
                </div>
                {(
                  data?.suiteAnchor?.length
                    ? value === item.label
                    : value === item.label || detailVal === item.label
                ) ? (
                  <Done
                    htmlColor="#00A0D1"
                    fontSize="small"
                  />
                ) : null}
              </MenuItem>
            ));
        })()}
      </Menu>
      <ExceptionDialog
        api={api}
        node={node}
        valueCheck={valueCheck}
        open={exceptionOpen}
        onClose={handleExpClose}
        data={data}
        type={type ? type : column?.getColId() === "coverageStatus" ? "account" : "workload"}
        selected={selected}
        // value={colId ? detailVal || value || "N/A" : value || "N/A"}
        colId={colId ? colId : (column?.getColId() as string)}
        updateCallback={updateCallback}
        showExpMark={Boolean(handleShowExp())}
        mutate={mutate}
      />
      {/* <EngagemntModelDialog
        api={api}
        node={node}
        valueCheck={valueCheck}
        open={open}
        onClose={handleClose}
        data={data}
        type={
          type
            ? type
            : column?.getColId() === "coverageStatus"
            ? "account"
            : "workload"
        }
        value={colId ? detailVal || value || "N/A" : value || "N/A"}
        colId={colId ? colId : (column?.getColId() as string)}
        updateCallback={updateCallback}
        showExpMark={Boolean(handleShowExp())}
        mutate={mutate}
      /> */}
    </div>
  );
};

export default classHOC(CoverageStatusRenderer);
